import { Flex, Switch } from 'antd'
import { SelectProps } from 'antd/lib'
import { Control, Controller, FieldValues, Path } from 'react-hook-form'
import { cn } from 'utils/common'

interface IProps<T extends FieldValues>
  extends Pick<SelectProps, 'suffixIcon' | 'className' | 'defaultValue' | 'value'> {
  label?: string
  control?: Control<T>
  name: Path<T>
  helperText?: string
  onChange?: (e: boolean) => void
}

export default function BaseSwitch<T extends FieldValues = FieldValues>(props: IProps<T>) {
  const { label, className, onChange } = props

  return (
    <>
      {props.control ? (
        <Controller
          control={props.control}
          name={props.name}
          render={({ field: { value, onChange }, fieldState: { error } }) => (
            <>
              {label && <label className='text-base text-neutral-700 font-medium'>{label}</label>}
              <div className={cn('custom-switch', className)}>
                <Switch checked={value} onChange={onChange} defaultChecked />
              </div>
              {error && <div className='text-error text-sm pt-1'>{error.message}</div>}
            </>
          )}
        />
      ) : (
        <Flex className={cn('items-center gap-4')}>
          {label && <label className='text-base text-neutral-700 font-medium'>{label}</label>}
          <div className={cn('custom-switch', className)}>
            <Switch checked={props.value} onChange={(e) => onChange && onChange(e)} defaultChecked />
          </div>
        </Flex>
      )}
    </>
  )
}
